import { Button } from '@/components/ui-kit/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui-kit/card';

import { Link } from 'react-router-dom';

import { ArrowLeft, FileText } from 'lucide-react';

import { useTranslation } from 'react-i18next';
import { Template } from '../../types/templates.types';

const ComingSoon = ({ template }: { template: Template }) => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-linear-to-b from-[hsl(var(--bg))] to-[hsl(var(--gradient-light-to))]">
      <div className="container max-w-4xl mx-auto px-4 py-4 sm:py-8 lg:py-12">
        <Link
          to={`/`}
          className="inline-flex items-center gap-2 text-sm font-medium text-globe-grey hover:text-selise-blue mb-4 sm:mb-6 transition-colors group"
        >
          <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
          {t('TEMPLATES_GENERATEPAGE_BACKTOTEMPLATES')}
        </Link>

        <div className="relative">
          {/* Decorative background elements */}
          <div className="absolute -top-8 -left-8 w-64 h-64 bg-[hsl(var(--selise-blue)/0.05)] rounded-full blur-3xl -z-10" />
          <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-[hsl(var(--sky-blue)/0.05)] rounded-full blur-3xl -z-10" />

          <Card className="border-border shadow-xl bg-card backdrop-blur-sm relative overflow-hidden">
            {/* Subtle gradient overlay */}
            <div className="absolute inset-0 bg-linear-to-br from-[hsl(var(--selise-blue)/0.02)] via-transparent to-[hsl(var(--sky-blue)/0.02)] pointer-events-none" />

            <CardHeader className="text-center pb-4 sm:pb-6 pt-6 sm:pt-10 px-4 sm:px-8 relative">
              <div className="mx-auto w-14 h-14 sm:w-20 sm:h-20 rounded-2xl bg-linear-to-br from-[hsl(var(--selise-blue)/0.15)] to-[hsl(var(--sky-blue)/0.15)] flex items-center justify-center mb-4 sm:mb-6 shadow-lg p-2 sm:p-3">
                <img
                  src="/Selise Legal Templates.svg"
                  alt="SELISE Legal Templates"
                  width={56}
                  height={56}
                  className="w-full h-full object-contain"
                />
              </div>

              <CardTitle className="text-xl sm:text-3xl lg:text-4xl font-bold text-[hsl(var(--fg))] mb-3 sm:mb-4 font-heading">
                {template.title}
              </CardTitle>
              <CardDescription className="text-sm sm:text-base lg:text-lg text-globe-grey max-w-2xl mx-auto leading-relaxed">
                {template.description}
              </CardDescription>
            </CardHeader>

            <CardContent className="text-center space-y-5 sm:space-y-8 px-4 sm:px-8 pb-6 sm:pb-10 relative">
              <div className="space-y-3 sm:space-y-4">
                <p className="text-globe-grey max-w-lg mx-auto text-sm sm:text-base leading-relaxed">
                  {t('TEMPLATES_GENERATEPAGE_COMINGSOONMESSAGE')}
                </p>

                {template.estimatedMinutes && (
                  <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg bg-[hsl(var(--bg))] border border-border text-xs sm:text-sm text-globe-grey">
                    <FileText className="h-4 w-4 text-selise-blue" />
                    <span>
                      {t('TEMPLATES_GENERATEPAGE_ESTIMATEDCOMPLETION', {
                        minutes: template.estimatedMinutes,
                      })}
                    </span>
                  </div>
                )}
              </div>

              <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2 sm:pt-4">
                <Button asChild variant="primary" size="sm">
                  <Link to={`https://legal-templates.com/en/templates`}>
                    {t('TEMPLATES_BROWSEAVAILABLETEMPLATES')}
                  </Link>
                </Button>
                <Button asChild variant="outline" size="sm" className="border-border">
                  <Link to={`/`}>{t('TEMPLATES_GENERATEPAGE_BACKTOHOME')}</Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
